import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import { CarouselV3 } from "@lululemon/ufs-shared";
import { ErrorBoundary } from "@lululemon/mwa-logger";

import FranchiseComparisonItem from "./franchise-comparison-item";
import { productEdHandleError } from "../../utils/product-education-logger";

import styles from "./franchise-comparison.module.scss";

const MOBILE_SLIDES_PER_PAGE = 2.14;
const TABLET_SLIDES_PER_PAGE = 3;
const DESKTOP_SLIDES_PER_PAGE = 4;

function FranchiseComparison({
  heading,
  items,
  deviceType,
  handleItemButtonLinkClick,
  handleCarouselIndexChange
}) {
  const carouselRef = React.useRef();
  const [verticalCenterRef, setVerticalCenterRef] = React.useState(null);

  const franchiseImgCallbackRef = React.useCallback((node) => {
    setVerticalCenterRef(node);
  }, []);

  let slidesToShow = DESKTOP_SLIDES_PER_PAGE;

  if (deviceType.isMobile) {
    slidesToShow = MOBILE_SLIDES_PER_PAGE;
  } else if (deviceType.isTablet) {
    slidesToShow = TABLET_SLIDES_PER_PAGE;
  } else {
    slidesToShow = DESKTOP_SLIDES_PER_PAGE;
  }

  const headingId = "franchise-comparison-hdg";

  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(
          error,
          "Franchise Comparison",
          "Franchise Comparison"
        )
      }
    >
      <div
        className={cs(
          "wrapper container-fluid",
          styles.outerContainer,
          "OneLinkNoTx"
        )}
      >
        {heading && (
          <h2 className={cs("lll-text-medium", styles.heading)} id={headingId}>
            {heading}
          </h2>
        )}
        {items && (
          <div className={cs("row", styles.wrapper)}>
            <CarouselV3
              ariaLabelledbyId={headingId}
              frameAriaLabel={`${heading} Carousel Slides`}
              innerRef={carouselRef}
              slidesToShow={slidesToShow}
              verticalCenterRef={verticalCenterRef}
              onUserNavigation={handleCarouselIndexChange}
              handleLeftArrowClick={handleCarouselIndexChange}
              handleRightArrowClick={handleCarouselIndexChange}
              wrapAround={false}
              disableEdgeSwiping={true}
              deviceType={deviceType}
            >
              {items?.map((item, index) => {
                const { franchiseName } = item?.fields || {};

                return (
                  <FranchiseComparisonItem
                    {...item?.fields}
                    franchiseImgCallbackRef={franchiseImgCallbackRef}
                    index={index}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${franchiseName}-${index}`}
                    handleButtonLinkClick={handleItemButtonLinkClick}
                  />
                );
              })}
            </CarouselV3>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}

FranchiseComparison.defaultProps = {
  heading: "",
  items: []
};

FranchiseComparison.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        activityIcon: PropTypes.string,
        activityText: PropTypes.string,
        button: PropTypes.object,
        franchiseComparisonItemDetails: PropTypes.array,
        franchiseName: PropTypes.string,
        image: PropTypes.object
      })
    })
  ),
  deviceType: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isDesktop: PropTypes.bool
  }).isRequired,
  handleItemButtonLinkClick: PropTypes.func,
  handleCarouselIndexChange: PropTypes.func
};

export default FranchiseComparison;
